import styled from 'styled-components';
import { updateObjectNestedProperties } from '../../../functions/objectFunctions/updateObjectNestedProperties';
import { useElements, useScene } from '../../../hooks';
import { LauncherElement } from '../../../types/launcherElement';
import { sizeUnits } from '../../../types/units';
import { UnitInput } from '../inputs/UnitInput';

export const SizeInputGroup = () => {
  const scene = useScene();
  const lastSelectedElementID = scene.selectedElementIDs.slice(-1)[0];
  const [selectedElement, setSelectedElement] = useElements<LauncherElement>({
    id: lastSelectedElementID,
  });

  const elementSize = {
    width: selectedElement?.props?.class?.width,
    height: selectedElement?.props?.class?.height,
  };

  const updateStyleProp = (propName: string, value: any) => {
    setSelectedElement((prev) =>
      updateObjectNestedProperties(prev, {
        [`props.class.${propName}`]: value,
      })
    );
  };

  return (
    <>
      <Container>
        <UnitInput
          id={`${lastSelectedElementID}-width-input`}
          label="w"
          placeholder="auto"
          value={elementSize.width}
          precision={2}
          units={sizeUnits}
          defaultUnit="px"
          onChange={(newValue) => updateStyleProp('width', newValue)}
          centered
        />
        <UnitInput
          id={`${lastSelectedElementID}-height-input`}
          label="h"
          placeholder="auto"
          value={elementSize.height}
          precision={2}
          units={sizeUnits}
          defaultUnit="px"
          onChange={(newValue) => updateStyleProp('height', newValue)}
          centered
        />
      </Container>
    </>
  );
};

const Container = styled.div<{ centered?: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 25px;
  display: flex;
  gap: 10px;
`;
